import React, { useState } from "react";
import { d3, gettext } from "../../adapter";
import moment from "moment";
import { ReactComponent as InformationIcon } from "./../../images/svg/information.svg";
import { ReactComponent as LoadingIcon } from "./../../images/svg/loader.svg";
import { ReactComponent as ExportIcon } from "./../../images/svg/export.svg";
import { ReactComponent as ArrowDownIcon } from "./../../images/svg/arrowDown.svg";
import AllBrush from "./AllBrush";
import { export2csv, applyFullDateRange } from "../../utils/allStationUtils";
import DateRangeField from "../shared/DateRangeField";
import DataGrid from "../shared/DataGrid";

const RawChart = ({ station, isFetching, dispatch, apiUrl }) => {
  const [exportOpen, setExportOpen] = useState(false);

  var meta = station.meta;
  var hcolumns = [
    { name: "date", title: "Date", width: 100 },
    { name: "time", title: "Time", width: 70 },
  ];
  for (var i = 0; i < meta.length; i++) {
    hcolumns.push({
      name: meta[i].key,
      title: meta[i].key.replace("__depths__", " ") + " " + meta[i].unit,
      resizable: true,
    });
  }

  var dataSethour = [];

  var exportClass = "panel-options__item dropdown__wrapper";
  if (exportOpen) {
    exportClass = "panel-options__item dropdown__wrapper is-open";
  }

  var preloaderClass = "object-preloader is-loaded";
  if (isFetching) {
    preloaderClass = "object-preloader is-loading";
  }

  if (!station) return <div />;

  if (station.measurements.length === 0) {
    return (
      <div>
        <div>
          <div className="l-full">
            <div className="panel has-object-preloader">
              <div className={preloaderClass}>
                <div className="object-preloader--content">
                  <LoadingIcon className="loader" />
                </div>
              </div>
              <h2>{station.name}</h2>
              <p>{gettext("This depth lacks sufficient measurements for displaying a graph.")}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  var meas = station.measurements;
  dataSethour = [];
  var d = new Date();
  var offset = d.getTimezoneOffset() * 1000 * 60;
  for (i = meas.length - 1; i >= 0; i--) {
    d = new Date(meas[i].timestamp * 1000 + offset);
    var rec = {
      id: meas[i].timestamp,
      date: moment(d).format("L"),
      time: moment(d).format("LT"),
    };
    for (var j = 0; j < meta.length; j++) {
      rec[meta[j].key] = meas[i].values[j];
    }
    dataSethour.push(rec);
  }

  // grafiekwaarden vullen en scalen
  station.graph = [];
  station.chartdata = [];
  offset = 0;
  var scale = 1;
  for (j = 0; j < meta.length; j++) {
    scale = 100 / (meta[j].domain[1] - meta[j].domain[0]);
    offset = -(scale * meta[j].domain[0]);
    var arr = [];
    var carr = [];
    for (i = 0; i < meas.length; i++) {
      d = new Date(meas[i].timestamp * 1000 + offset);
      if (meas[i].values[j]) {
        arr.push({ timestamp: d, y: meas[i].values[j] * scale + offset });
        carr.push(meas[i].values[j]);
      } else {
        arr.push({ timestamp: d, y: 0 + offset });
        carr.push(0);
      }
    }

    // lege sensoren verwijderen:

    var extent = d3.extent(carr);
    if (extent[0] !== extent[1]) {
      station.graph.push(arr);
      station.chartdata.push(carr);
    } else {
      station.meta.splice(j, 1);
      j--;
    }
  }

  return (
    <div>
      <div>
        <div className="l-full">
          <div className="panel has-object-preloader">
            <div className={preloaderClass}>
              <div className="object-preloader--content">
                <LoadingIcon className="loader" />
              </div>
            </div>

            <h2>
              {station.name} {gettext("date range filter")}
              <DateRangeField
                startDate={station.firstDataPointDate}
                endDate={station.lastDataPointDate}
                minDate={station.startDate}
                maxDate={new Date()}
                onApply={applyFullDateRange(apiUrl, station, dispatch)}
              />
            </h2>
            <AllBrush station={station} />
          </div>
        </div>
      </div>

      <div className="l-full">
        <div className="panel has-object-preloader">
          <div className={preloaderClass}>
            <div className="object-preloader--content">
              <LoadingIcon className="loader" />
            </div>
          </div>

          <div className="panel--header">
            <ul className="panel-options">
              <li
                className={exportClass}
                onClick={() => {
                  setExportOpen(!exportOpen);
                }}
              >
                {/* eslint-disable-next-line */}
                <a className="dropdown--toggle">
                  <ExportIcon className="icon" /> {gettext("Export")}
                </a>

                <div className="dropdown">
                  <ul className="dropdown__list">
                    <li>
                      {/* eslint-disable-next-line */}
                      <a onClick={() => export2csv(station)}>{gettext("To CSV")}</a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>

            <div className="panel--settings">
              <div className="dropdown">
                {/* eslint-disable-next-line */}
                <a className="dropdown--toggle">
                  <ArrowDownIcon className="icon dropdown--arrow" />
                  {gettext("Export")}
                </a>
                <div className="dropdown--popout ">
                  <ul className="dropdown--list">
                    <li>
                      {/* eslint-disable-next-line */}
                      <a onClick={() => export2csv(station)}>{gettext("To CSV")}</a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="panel--settings__item">
                <div
                  id="information"
                  className="dropdown"
                  onClick={function () {
                    var info = document.querySelector("#information"); // Using a class instead, see note below.
                    info.classList.toggle("is-open");
                  }}
                >
                  {/* eslint-disable-next-line */}
                  <a className="panel--settings__icon">
                    <InformationIcon className="icon" />
                  </a>
                  <div className="dropdown--popout is-visible dropdown--popout__moretop dropdown--popout__wide">
                    <div className="dropdown--popout__content">
                      <p>Ik ben de HTML content</p>
                      <h3>test</h3>
                      <p>Ik ben de HTML content</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <DataGrid
            rows={dataSethour}
            columns={hcolumns.map((c) => ({ key: c.name, title: c.title, type: c.type }))}
            maxHeight={400}
          />
          <br />
        </div>
      </div>
    </div>
  );
};

export default RawChart;
